// import React, { Suspense, lazy } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { LanguageProvider } from './contexts/LanguageContext';

// const HomePage = lazy(() => import('./HomePage'));
// const PlanPrivate = lazy(() => import('./pages/PlanPrivate'));
// const PlanO3Pro = lazy(() => import('./pages/PlanO3Pro'));
// const PlanFamily = lazy(() => import('./pages/PlanFamily'));
// const PlanStudent = lazy(() => import('./pages/PlanStudent'));
// const PlanThreeMonth = lazy(() => import('./pages/PlanThreeMonth'));
// const PaymentCallback = lazy(() => import('./components/PaymentCallback'));
// const BlogList = lazy(() => import('./pages/BlogList'));
// const BlogPost = lazy(() => import('./pages/BlogPost'));
// const AdminCodeVerifier = lazy(() => import('./pages/AdminCodeVerifier'));
// const CodeTester = lazy(() => import('./pages/CodeTester'));
// const CoursePage = lazy(() => import('./pages/CoursePage'));
// const AboutUs = lazy(() => import('./pages/AboutUs'));
// const Founder = lazy(() => import('./pages/Founder'));
// const CoFounder = lazy(() => import('./pages/CoFounder'));
// const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
// const TermsOfService = lazy(() => import('./pages/TermsOfService'));
// const ContactUs = lazy(() => import('./pages/ContactUs'));
// const TestBlogList = lazy(() => import('./pages/test_blog_list'));
// const AITools = lazy(() => import('./pages/AITools'));

// function App() {
//   return (
//     <LanguageProvider>
//       <Router>
//         <div className="App">
//           {/* Global animated aurora background for all pages */}
//           <div className="aurora-bg">
//             <div className="aurora-orb aurora-cyan orb1"></div>
//             <div className="aurora-orb aurora-purple orb2"></div>
//             <div className="aurora-orb aurora-cyan orb3"></div>
//             <div className="aurora-orb aurora-purple orb4"></div>
//             <div className="aurora-orb aurora-cyan orb5"></div>
//             <div className="aurora-orb aurora-purple orb6"></div>
//             <div className="aurora-orb aurora-cyan orb7"></div>
//           </div>
//           {/* Content wrapper to ensure it's on top of the background */}
//           <div className="relative z-10">
//           <Suspense fallback={<div>Loading...</div>}>
//             <Routes>
//               <Route path="/" element={<HomePage />} />
//               {/* <Route path="/signup" element={<SignupLoginPage />} /> */}
//               {/* <Route path="/login" element={<SignupLoginPage />} /> */}
//               <Route path="/plans/private" element={<PlanPrivate />} />
//               <Route path="/plans/o3pro" element={<PlanO3Pro />} />
//               <Route path="/plans/family" element={<PlanFamily />} />
//               <Route path="/plans/student" element={<PlanStudent />} />
//               <Route path="/plans/chatgpt-plus-first-subscription" element={<PlanThreeMonth />} />
//               <Route path="/course/codex" element={<CoursePage />} />
//               <Route path="/payment-callback" element={<PaymentCallback />} />
//               <Route path="/blog" element={<BlogList />} />
//               <Route path="/blog/:slug" element={<BlogPost />} />
//               <Route path="/admin/verify-code" element={<AdminCodeVerifier />} />
//               {/* <Route path="/test/code-generator" element={<CodeTester />} /> */}
//               <Route path="/about" element={<AboutUs />} />
//               <Route path="/team/amirelmtalab" element={<Founder />} />
//               <Route path="/team/erfanelmtalab" element={<CoFounder />} />
//               <Route path="/privacy" element={<PrivacyPolicy />} />
//               <Route path="/terms" element={<TermsOfService />} />
//               <Route path="/contact" element={<ContactUs />} />
//               <Route path="/products" element={<Products />} />
//               <Route path="/product/:slug" element={<CMSProduct />} />
//               <Route path="/test-blog-list" element={<TestBlogList />} />
//               <Route path="/admin/thompson-dashboard" element={<ThompsonDashboard />} />
//               <Route path="/bluemoon" element={<BluemoonIndex />} />
//               <Route path="/ai-accounts" element={<AIAccounts />} />
//               <Route path="/premium-accounts" element={<PremiumAccounts />} />
//               <Route path="/currency-payment" element={<CurrencyPayment />} />
//             </Routes>
//           </Suspense>
//           </div>
//         </div>
//       </Router>
//     </LanguageProvider>
//   );
// }

// export default App;

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';

const HomePage = lazy(() => import('./HomePage'));
const BluemoonHomePage = lazy(() => import('./bluemoon/HomePage'));
const BluemoonProductPage = lazy(() => import('./bluemoon/ProductPage'));
const BluemoonAboutUs = lazy(() => import('./bluemoon/AboutUs'));
const BluemoonContactUs = lazy(() => import('./bluemoon/ContactUs'));
const BluemoonFAQ = lazy(() => import('./bluemoon/FAQ'));
const BluemoonTermsOfService = lazy(() => import('./bluemoon/TermsOfService'));
const BluemoonPrivacyPolicy = lazy(() => import('./bluemoon/PrivacyPolicy'));
const PlanPrivate = lazy(() => import('./pages/PlanPrivate'));
const PlanO3Pro = lazy(() => import('./pages/PlanO3Pro'));
const PlanFamily = lazy(() => import('./pages/PlanFamily'));
const PlanStudent = lazy(() => import('./pages/PlanStudent'));
const PaymentCallback = lazy(() => import('./components/PaymentCallback'));
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const AdminCodeVerifier = lazy(() => import('./pages/AdminCodeVerifier'));
const CodeTester = lazy(() => import('./pages/CodeTester'));
const CoursePage = lazy(() => import('./pages/CoursePage'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Founder = lazy(() => import('./pages/Founder'));
const CoFounder = lazy(() => import('./pages/CoFounder'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const TestBlogList = lazy(() => import('./pages/test_blog_list'));

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          {/* Global animated aurora background for all pages */}
          <div className="aurora-bg">
            <div className="aurora-orb aurora-cyan orb1"></div>
            <div className="aurora-orb aurora-purple orb2"></div>
            <div className="aurora-orb aurora-cyan orb3"></div>
            <div className="aurora-orb aurora-purple orb4"></div>
            <div className="aurora-orb aurora-cyan orb5"></div>
            <div className="aurora-orb aurora-purple orb6"></div>
            <div className="aurora-orb aurora-cyan orb7"></div>
          </div>
          {/* Content wrapper to ensure it's on top of the background */}
          <div className="relative z-10">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<BluemoonHomePage category="premium" />} />
              <Route path="/bluemoon" element={<BluemoonHomePage category="premium" />} />
              <Route path="/premium-accounts" element={<BluemoonHomePage category="premium" />} />
              <Route path="/ai-accounts" element={<BluemoonHomePage category="ai" />} />
              <Route path="/payment-services" element={<BluemoonHomePage category="payment" />} />
              <Route path="/product/:slug" element={<BluemoonProductPage />} />
              <Route path="/bluemoon/products" element={<BluemoonProductPage />} />
              <Route path="/about" element={<BluemoonAboutUs />} />
              <Route path="/contact" element={<BluemoonContactUs />} />
              <Route path="/faq" element={<BluemoonFAQ />} />
              <Route path="/terms" element={<BluemoonTermsOfService />} />
              <Route path="/privacy" element={<BluemoonPrivacyPolicy />} />
              {/* <Route path="/signup" element={<SignupLoginPage />} /> */}
              {/* <Route path="/login" element={<SignupLoginPage />} /> */}
              <Route path="/plans/private" element={<PlanPrivate />} />
              <Route path="/plans/o3pro" element={<PlanO3Pro />} />
              <Route path="/plans/family" element={<PlanFamily />} />
              <Route path="/plans/student" element={<PlanStudent />} />
              <Route path="/course/codex" element={<CoursePage />} />
              <Route path="/payment-callback" element={<PaymentCallback />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin/verify-code" element={<AdminCodeVerifier />} />
              {/* <Route path="/test/code-generator" element={<CodeTester />} /> */}
              <Route path="/about" element={<AboutUs />} />
              <Route path="/team/amirelmtalab" element={<Founder />} />
              <Route path="/team/erfanelmtalab" element={<CoFounder />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/test-blog-list" element={<TestBlogList />} />
            </Routes>
          </Suspense>
          </div>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
